import { useEffect, useState } from "react";
import { BackgroundImage } from "@/components/backgroundImage"
import { ButtonLink } from "@/components/buttonLink";
import { ViewForm } from "@/components/viewForm";
import { ViewSelect } from "@/components/viewSelect";
import { ViewLinks } from "@/components/viewLinks";
import { pedagogico } from "@/constants/pedagogico";
import { useLocation } from "react-router-dom";
import { useCookies } from "@/hooks/useCookies";
import { LogoHeader } from "@/components/logoHeader";


function ServicosPedagogico() {
  const [servico, setServico] = useState(null);
  const location = useLocation();
  const path = location.pathname.split("/").filter(Boolean).pop()

  useEffect(() => {
    let serico_select = pedagogico.find(item => item.id === path)
    setServico(serico_select)
  }, []);

  useCookies()

  return (
    <div className="mx-auto max-w-[500px] min-h-screen px-2 pb-8">
      <LogoHeader />
      <div className="flex flex-col galp-4 px-4">

        {servico ? <BackgroundImage height="h-[300px]" alt="Duplicate-amico.png" src="/assets/Duplicate-amico.png" /> :
          <BackgroundImage height="h-[300px]" alt="404.png" src="/assets/404.png" />}

        {servico ?
          (<p className="text-2xl font-bold text-center">
            {servico.label}
          </p>) :
          (<div className="flex flex-col gap-3">
            <p className="text-2xl font-bold text-center">
              Serviço não encontrado!
            </p>
            <div className="px-4">
              <ButtonLink href="/">IR PARA O INÍCIO</ButtonLink>
            </div>
          </div>)}

        {servico && servico.view.type === "form" && <ViewForm components={servico.view.options} backPage="/setor/pedagogico" initialValues={servico.view.options.filter(item => item.id).reduce((acc, item) => { acc[item.id] = item.defaultValue; return acc; }, {})} />}
        {servico && servico.view.type === "select" && <ViewSelect components={servico.view.options} backPage="/setor/pedagogico" />}
        {servico && servico.view.type === "links" && <ViewLinks components={servico.view.options} backPage="/setor/pedagogico" />}
      </div>

    </div>
  )
}

export default ServicosPedagogico

